import { actionType } from "../../helpers/reducers";

// Pages
export const PAGE_SET = "page/SET";
export const PAGE_SET_MULTIPLE = "page/SET_MULTIPLE";
export const PAGE_CLEAR = "page/CLEAR";
export const PAGE_REMOVE = "page/REMOVE";

export const setPage = actionType(PAGE_SET);

// API
export const PAGE_FETCH = "page/FETCH";
export const PAGE_FETCH_ALL = "page/FETCH_ALL";
export const PAGE_SAVE = "page/SAVE";
export const PAGE_SET_POSITION = "page/SET_POSITION";
export const PAGE_CREATE = "page/CREATE";
export const PAGE_DESTROY = "page/DESTROY";

export const fetchPage = actionType(PAGE_FETCH);
export const fetchPages = actionType(PAGE_FETCH_ALL);
export const createPage = actionType(PAGE_CREATE);
export const savePage = actionType(PAGE_SAVE);
export const setPagePositions = actionType(PAGE_SET_POSITION);
export const destroyPage = actionType(PAGE_DESTROY);
